import { j as o } from "../../_virtual/jsx-runtime.js";
const e = ({
  width: r = 20,
  height: s = 20,
  viewBox: t = "0 0 20 20",
  fill: C = "currentColor",
  ...V
}) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: s,
    viewBox: t,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...V,
    children: /* @__PURE__ */ o.jsx(
      "path",
      {
        d: "M15.8333 8.33332H16.6667C17.1269 8.33332 17.5 8.70641 17.5 9.16666V17.5C17.5 17.9602 17.1269 18.3333 16.6667 18.3333H3.33333C2.8731 18.3333 2.5 17.9602 2.5 17.5V9.16666C2.5 8.70641 2.8731 8.33332 3.33333 8.33332H4.16667V7.49999C4.16667 4.27833 6.77834 1.66666 10 1.66666C13.2217 1.66666 15.8333 4.27833 15.8333 7.49999V8.33332ZM4.16667 9.99999V16.6667H15.8333V9.99999H4.16667ZM9.16667 11.6667H10.8333V15H9.16667V11.6667ZM14.1667 8.33332V7.49999C14.1667 5.19881 12.3012 3.33332 10 3.33332C7.69882 3.33332 5.83333 5.19881 5.83333 7.49999V8.33332H14.1667Z",
        fill: C
      }
    )
  }
);
export {
  e as default
};
